import { size } from 'lodash';

export default str => {
  const processedString = new Date(str).toLocaleDateString('en-US');
  const date = processedString.split('/');
  date[0] = size(date[0]) === 1 ? `0${date[0]}` : date[0];
  date[1] = size(date[1]) === 1 ? `0${date[1]}` : date[1];
  return `${date[2]}-${date[0]}-${date[1]}`;
};
